<template>
    <div class="match-details__stats-container" v-show="!isShowNoData">
        <div class="match-detail__stats-wrapper">
            <div class="match-detail__stats-header recent-meeting-title">
                {{ $t("RECENT_MEETINGS") }}
            </div>
        </div>

        <div class="recent-meetings-list">
            <template v-for="(o, index) in matchList" :key="index">
                <div class="recent-meetings-item">
                    <div class="recent-meetings-logo-name">
                        {{ o.leagueName }}
                    </div>
                    <div class="recent-meeting-item-box">
                        <div class="recent-meetings-logo">
                            <Navigation
                                :id="o.homeTeamId"
                                :category="'team'"
                                :name="o.homeTeamName"
                            >
                                <Icon
                                    :logoUrl="o.homeLogo"
                                    hasClass="recent-meetings-logo-icon"
                                ></Icon>
                                <div
                                    class="recent-meetings-logo-p p-left"
                                    v-if="
                                        o.homeTeamPenaltyScore !== null &&
                                        o.homeTeamPenaltyScore >
                                            o.awayTeamPenaltyScore
                                    "
                                >
                                    P
                                </div>
                            </Navigation>
                        </div>

                        <div class="recent-meetings-content">
                            <div class="recent-meetings-logo">
                                <!-- <Icon
                                    :logoUrl="o.scoreLogo"
                                    hasClass="recent-meetings-logo-icon score"
                                ></Icon> -->
                            </div>
                            <div
                                class="recent-meetings-score"
                                :class="{
                                    'pen-exists':
                                        o.homeTeamPenaltyScore !== null &&
                                        o.awayTeamPenaltyScore !== null,
                                }"
                            >
                                <div class="recent-meetings-score-text">
                                    <div
                                        class="recent-meetings-red-card-list home-red-card"
                                    >
                                        <div
                                            v-for="s in o.homeRed"
                                            class="red-card-item"
                                        ></div>
                                    </div>
                                    <div class="recent-meetings-score-value">
                                        {{ o.homeTeamScore }}
                                    </div>
                                </div>
                                <div class="socre-dash">-</div>
                                <div class="recent-meetings-score-text">
                                    <div class="recent-meetings-score-value">
                                        {{ o.awayTeamScore }}
                                    </div>
                                    <div
                                        class="recent-meetings-red-card-list away-red-card"
                                    >
                                        <div
                                            v-for="s in o.awayRed"
                                            class="red-card-item"
                                        ></div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="recent-meetings-pen"
                                v-if="
                                    o.homeTeamPenaltyScore !== null &&
                                    o.awayTeamPenaltyScore !== null
                                "
                            >
                                {{ $t("PEN") }}: {{ o.homeTeamPenaltyScore }} -
                                {{ o.awayTeamPenaltyScore }}
                            </div>
                            <div class="recent-meetings-date">
                                <!-- {{o.matchStatus}}, -->
                                {{ fomatDate(o.matchTime) }}
                            </div>
                        </div>

                        <div class="recent-meetings-logo">
                            <Navigation
                                :id="o.awayTeamId"
                                :category="'team'"
                                :name="o.awayTeamName"
                            >
                                <Icon
                                    :logoUrl="o.awayLogo"
                                    hasClass="recent-meetings-logo-icon"
                                ></Icon>
                                <div
                                    class="recent-meetings-logo-p p-right"
                                    v-if="
                                        o.awayTeamPenaltyScore !== null &&
                                        o.awayTeamPenaltyScore >
                                            o.homeTeamPenaltyScore
                                    "
                                >
                                    P
                                </div>
                            </Navigation>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import config from "@/js/config.js";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
    name: "RecentMeeting",
    data() {
        return {
            cnLocaleList: config.cnLocaleList,
            fakeData: [
                {
                    homeLogo: "football/gs/team/611/8856.png",
                    awayLogo: "football/gs/team/611/1098.png",
                    scoreLogo: "football/gs/team/1169/7881.png",
                    name: "Spanish La Liga",
                    homeScore: 5,
                    awayScore: 0,
                    homeRedCard: 0,
                    awayRedCard: 0,
                    homePenati: false,
                    awayPenati: false,
                    date: "FT, 22 Dec 2023",
                },
                {
                    homeLogo: "football/gs/team/611/1098.png",
                    awayLogo: "football/gs/team/611/8856.png",
                    scoreLogo: "football/gs/team/1169/7881.png",
                    name: "Spanish La Liga",
                    homeScore: 12,
                    awayScore: 1,
                    homeRedCard: 3,
                    awayRedCard: 1,
                    homePenati: false,
                    awayPenati: false,
                    date: "Aban, 22 Dec 2023",
                },
                {
                    homeLogo: "football/gs/team/611/8856.png",
                    awayLogo: "football/gs/team/611/1098.png",
                    scoreLogo: "football/gs/team/1169/7881.png",
                    name: "Spanish La Liga",
                    homeScore: 2,
                    awayScore: 2,
                    homeRedCard: 3,
                    awayRedCard: 2,
                    homePenati: true,
                    awayPenati: true,
                    date: "FT, 22 Dec 2023",
                    pen: "5 - 3",
                },
                {
                    homeLogo: "football/gs/team/611/8856.png",
                    awayLogo: "football/gs/team/611/1098.png",
                    scoreLogo: "football/gs/team/1169/7881.png",
                    name: "Spanish La Liga",
                    homeScore: 5,
                    awayScore: 0,
                    homeRedCard: 0,
                    awayRedCard: 0,
                    homePenati: false,
                    awayPenati: false,
                    date: "FT, 22 Dec 2023",
                },
                {
                    homeLogo: "football/gs/team/611/1098.png",
                    awayLogo: "football/gs/team/611/8856.png",
                    scoreLogo: "football/gs/team/1169/7881.png",
                    name: "Spanish La Liga",
                    homeScore: 12,
                    awayScore: 1,
                    homeRedCard: 3,
                    awayRedCard: 1,
                    homePenati: false,
                    awayPenati: false,
                    date: "Aban, 22 Dec 2023",
                },
                {
                    homeLogo: "football/gs/team/611/8856.png",
                    awayLogo: "football/gs/team/611/1098.png",
                    scoreLogo: "football/gs/team/1169/7881.png",
                    name: "Spanish La Liga",
                    homeScore: 2,
                    awayScore: 2,
                    homeRedCard: 3,
                    awayRedCard: 2,
                    homePenati: true,
                    awayPenati: true,
                    date: "FT, 22 Dec 2023",
                    pen: "5 - 3",
                },
            ],
            isShowH2HAlert: false,
            isShowNoData: true,
            isLoading: false,
            isSkeletonLoading: {
                matchStat: false,
            },
        };
    },
    computed: {
        ...mapGetters([
            "isMobile",
            "currentSportType",
            "manualRefreshMatchDetail",
            "currentLocale",
        ]),
    },
    props: ["matchDetailScore"],
    created() {
        this.matchId = this.$route.params.matchId;
    },
    mounted() {
        this.getH2hInfoData();
    },
    methods: {
        ...mapMutations(["MANUAL_REFRESH_MATCH_DETAIL"]),
        ...mapActions(["getMatchDetailRecentMeeting"]),
        async getH2hInfoData(newVal) {
            this.isLoading = true;

            let params = {
                matchId: this.matchId,
                size: 6,
                timeZone: this.$tools.getCurrentTimeZone(),
            };
            if (this.manualRefreshMatchDetail) {
                this.isSkeletonLoading.h2h = true;
            }
            const result = await this.getMatchDetailRecentMeeting(params);
            if (this.manualRefreshMatchDetail) {
                this.isSkeletonLoading.h2h = false;
                this.verifyIfAllAPICallsDone();
            }

            this.matchList = result.result;

            this.isLoading = false;

            if (this.matchList) {
                if (this.matchList.length === 0) {
                    this.isShowNoData = true;
                } else {
                    this.isShowNoData = false;
                }
            } else {
                this.isShowNoData = true;
            }
        },
        verifyIfAllAPICallsDone() {
            if (!this.isSkeletonLoading.h2h) {
                this.MANUAL_REFRESH_MATCH_DETAIL();
            }
        },
        fomatDate(dateString) {
            let date = new Date(dateString);

            let result;

            if (this.currentLocale === "vn") {
                result = `${this.$i18n.t(
                    this.$tools.getFullDay(date.getDay())
                )},
                    ${date.getDate()} tháng ${date.getMonth() + 1} năm
                    ${date.getFullYear()} 
                
                `;
            } else if (this.cnLocaleList.includes(this.currentLocale)) {
                result = `
                    ${this.$i18n.t(this.$tools.getDay(date.getDay()))}, 
                    ${date.getDate()}日  
                    ${date.getMonth() + 1}月
                    ${date.getFullYear()}年
                    `;
            } else {
                result = `
                    ${this.$i18n.t(this.$tools.getDay(date.getDay()))},
                    ${date.getDate()} 
                    ${this.$i18n.t(this.$tools.getMonth(date.getMonth()))}
                    ${date.getFullYear()} 
                    `;
            }
            return result;
        },
    },
};
</script>

<style scoped>
.match-detail__stats-wrapper {
    margin: 0 auto;
}
.match-detail__stats-header {
    padding: 0 0 1.5rem 0;
    /* margin: 0 1rem; */
    text-align: left;
    font-family: var(--weight-700);
    text-align: center;
    font-size: var(--typography-body-size-large);
    margin-top: 24px;
    letter-spacing: 0.64px;
}
.recent-meetings-list {
}
.recent-meetings-item {
    padding: 10px 0 5.5px 0;
    border-bottom: 1px dashed var(--color-border-default-default);
}
.recent-meeting-item-box {
    display: flex;
    align-items: center;
    justify-content: center;
}
.recent-meetings-item:last-child {
    border-bottom: 0;
}
.recent-meetings-logo {
    display: flex;
    align-items: center;
    color: var(--color-text-default-secondary);
    font-size: 14px;
    position: relative;
    justify-content: center;
    letter-spacing: 0.64px;
    top: -6px;
}
.recent-meetings-logo-icon.score {
    width: 22px;
    height: 22px;
    border: 1px solid var(--gray-300);
    border-radius: 50%;
    margin-right: 4px;
}
.recent-meetings-logo-icon {
    width: 50.3px;
    height: 50.3px;
}
.recent-meetings-logo-p {
    position: absolute;
    background-color: var(--primary-500);
    width: 17px;
    height: 22px;
    color: var(--white-1000);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.recent-meetings-logo-p.p-left {
    top: -20px;
    right: 0;
}
.recent-meetings-logo-p.p-right {
    left: 0;
    top: -20px;
}
.recent-meetings-content {
    width: 184px;
    padding: 0 110px;
    text-align: center;
}
.recent-meetings-score {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--typography-heading-size-small);
    font-family: var(--weight-700);
    padding: 18px 0 13.5px;
    color: var(--color-text-default-default);
}
.pen-exists {
    padding-bottom: 0;
}
.recent-meetings-pen {
    font-family: var(--weight-600);
    color: var(--color-text-default-secondary);
    text-transform: uppercase;
    font-size: 14px;
}
.socre-dash {
    padding: 0 1rem;
}
.recent-meetings-date {
    color: var(--color-text-default-secondary);
    font-size: var(--typography-body-size-small);
    letter-spacing: 0.64px;
}
.recent-meetings-score-text {
    position: relative;
    display: flex;
    align-items: center;
}
.recent-meetings-red-card-list {
    display: flex;
    align-items: center;
}
.home-red-card {
    right: 30px;
    position: absolute;
}
.away-red-card {
    position: absolute;
    left: 30px;
}
.red-card-item {
    width: 6px;
    height: 8px;
    background-color: var(--card-red);
    border-radius: 1px;
    margin: 0 1.5px;
}
.recent-meetings-score-value {
    width: 30px;
}
.recent-meeting-title {
    margin-top: 24px;
    font-size: 32px;
    line-height: 120%;
    letter-spacing: -0.64px;
    font-family: var(--weight-600);
}
.match-details__stats-container {
    margin-bottom: 48px;
}
.recent-meetings-logo-name {
    /* display: none; */
    text-align: center;
    color: var(--color-text-default-secondary);
}
@media(max-width: 768px) {
    /* for test */
    .match-details__stats-container {
        background-color: var(--color-background-default-secondary);
        border-radius: 8px;
        margin-top: 16px;
        padding: 16px;
        margin-bottom: 16px;
    }
    .match-detail__stats-header {
        margin-top: 0;
        font-size: 24px;
        letter-spacing: -0.48px;
        font-family: var(--weight-600);
    }
    .recent-meetings-content {
        width: 155px;
        padding: 0 5px;
    }
    .recent-meetings-logo-p.p-left,
    .recent-meetings-logo-p.p-right {
        top: -10px;
    }
    .recent-meetings-score-text {
        display: block;
    }
    .recent-meetings-score .recent-meetings-score-text:nth-child(3) {
        display: flex;
        flex-direction: column-reverse;
    }

    .recent-meetings-logo {
        justify-content: center;
    }
    .recent-meetings-item {
        padding: 8px 0 11px;
    }
    .recent-meetings-logo-icon {
        margin-top: 1px;
    }
}
</style>
